module.exports = __webpack_public_path__ + "img/16.261ec3bf.jpg";